import React from 'react';
import './ChildSafety_PG_Content.css';

const automationFeatures = [
    {
        title: "Remote Control",
        image: "/Assets/ChildSafety/precise-control-with-a-remote.webp",
        content: "The Remote Control allows you to pre-set and easily operates a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall."
    },
    {
        title: "Smart Phone",
        image: "/Assets/ChildSafety/smart-phone.webp",
        content: "Callistus most of blinds are available with Motorization, which provides effortless, cordless operation. You can operate with remote and computable with home automation and smart home automation systems, you can program your blinds to reposition on a schedule that you set. Move your blinds on command."
    },
    {
        title: "One touch Up",
        image: "/Assets/ChildSafety/one-touch-up.webp",
        content: "One Touch Up is a smart system wherein you just need to pull the operating cord, and the blind will roll up on its own. One touch Up system enhances both beauty and safety."
    },
    {
        title: "One Touch Down",
        image: "/Assets/ChildSafety/one-touch-down.webp",
        content: "One Touch Down is a smart system wherein you just need to pull the operating chain, and the blind will start unfolding on its own. One touch down system enhances both beauty and safety."
    },
    {
        title: "Clutch Control",
        image: "/Assets/ChildSafety/cluch-system.webp",
        content: "Callistus Clutch System for Colby blinds uses a retractable cord to raise and lower your blind while maintaining a constant cord length. There are no long, dangling cords to detract from the appearance of your window covering which is Ideal for child and pet safety."
    },
    {
        title: "Wand Control",
        image: "/Assets/ChildSafety/wand-cantrol.webp",
        content: "Callistus offers Wand control for Sierra, Eton and Vertical Blinds, so making them completely Child Safe by Design. You can control the blind and draw it to either the left or right as per your need."
    },
    {
        title: "Fixed Tension Hook Device",
        image: "/Assets/ChildSafety/fixed-tension-hook-device.webp",
        content: "A hook fitted to an adjacent wall which chains and cords are hooked through to keep taut and out of reach of children."
    },
    {
        title: "Other tips on how to be child-safe",
        image: "/Assets/ChildSafety/child-friendly.webp",
        content: `Please install appropriate child safety devices for blinds when you are fitting it, also there are a couple of additional steps you can take to ensure that your blinds are child safe.
                <br />
                 – Keep all cords and chains out of the reach of children using the safety hooks and cleats which have been fitted for you.
                <br />
                 - Loose cords or chains should never be tied together.
                <br />
                 - Furniture that children could climb on should be kept away from your windows.`
    },
];

const ChildSafety_PG_Content = () => {
    return (
        <div className="cf-pg-content">
            <div className="cf-container">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Child Safety</h1>
                </div>

                <div className="cf-full-image">
                    <img src="/Assets/ChildSafety/child-safety-1140x676-1.webp" alt="Energy efficient windows" />
                </div>

                <div className="cf-Sec-Subtitle">
                    <p>
                        Children are unsurprisingly curious about the world just about them. So, even basic household items like window blinds can turn into prospective hazards for them. Making our window blinds safer for homes with infants, young children and pets is a top priority at Callistus. So we developed a wide range of operating system to help significantly reduce the risk of accidents by eliminating potentially unsafe free-hanging or exposed operating. From Clutch alternatives to motorized systems, we offer 10 innovative operating systems designed with safety, convenience and beauty in mind. Choose from an abundant array of colors, texture and materials that complement your nursery today and your teen’s room tomorrow.
                        <strong style={{ fontWeight: '700', display: 'inline-block' }}>MAKING OUR WINDOW FASHIONS SAFER FOR HOMES WITH INFANTS, YOUNG CHILDREN AND PETS IS A TOP PRIORITY AT CALLISTUS.</strong>
                    </p>
                </div>

                <div className="cf-features">
                    {automationFeatures.map((item, index) => (
                        <div className="cf-feature-row" key={index}>
                            <h4>{item.title}</h4>
                            <div className="cf-card">
                                <div className="cf-feature-image">
                                    <img src={item.image} alt={item.title} />
                                </div>
                                <div className="cf-feature-text">
                                    <p dangerouslySetInnerHTML={{ __html: item.content }}></p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default ChildSafety_PG_Content;